module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n4n8r7r-ecfaffab6d3a79674841cdacfb65f0db.svg";